/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MarginInputs */

const de__field_margin = /** @type {(inputs: _Field_MarginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Margin`)
};

/**

* @param {_Field_MarginInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_margin = /** @type {((inputs?: _Field_MarginInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MarginInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_margin(inputs)
});